import { render, staticRenderFns } from "./MultiUpload.vue?vue&type=template&id=4076ab34&scoped=true&"
import script from "./MultiUpload.vue?vue&type=script&lang=ts&"
export * from "./MultiUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4076ab34",
  null
  
)

export default component.exports